import { render, staticRenderFns } from "./ZinusCalendarWebpart.vue?vue&type=template&id=ed1de198"
import script from "./ZinusCalendarWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ZinusCalendarWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports